/** The provider and the one rich-text helper (spec §8.23); the logic lives in `core.ts`. */
import { useCallback, useMemo, type ReactNode } from "react";
import { I18nContext, translate, type Language, type Params } from "./core";

export function I18nProvider({ language, children }: { language: Language; children: ReactNode }) {
  const t = useCallback((key: string, params?: Params) => translate(language, key, params), [language]);
  const value = useMemo(() => ({ language, t }), [language, t]);
  return <I18nContext value={value}>{children}</I18nContext>;
}

/**
 * A translated message with emphasis in it: `<b>…</b>` in the catalogue becomes `<strong>`. The
 * markers stay in the message so a translator decides where the emphasis falls in their sentence,
 * which splitting a sentence into separately translated pieces would take from them.
 */
export function Rich({ text, strong = "font-medium" }: { text: string; strong?: string }) {
  const parts = text.split(/<b>(.*?)<\/b>/g);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <strong key={i} className={strong}>
            {part}
          </strong>
        ) : (
          part
        ),
      )}
    </>
  );
}
